export default {
  Partner: {
    fields: {
      quizzes: { merge: false },
      channels: { merge: false },
      onboarding: { merge: true },
      pricing: { merge: false },
    },
  },
  PartnerSettings: {
    fields: {
      bills: { merge: false },
    },
  },
  PartnerNews: {
    fields: {
      reactions: { merge: false },
    },
  },
};
